














import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class MovieBase extends Vue {
  @Prop()
  private src!: string

  @Prop()
  private poster?: string

  @Prop({ default: 'video/mp4' })
  private type?: string

  @Prop({ default: '16/9' })
  private ratio!: string

  @Prop({ default: '100%' })
  private width!: string

  @Prop({ default: true })
  private controls?: boolean

  @Prop({ default: false })
  private autoplay?: boolean

  @Prop({ default: true })
  private disablePictureInPicture?: boolean

  @Prop({ default: 'nodownload nofullscreen' })
  private controlsList?: string

  @Prop({ default: 'return false' })
  private onContextMenu?: string

  get setStyle(): { [key: string]: string } {
    const { ratio, width } = this

    return {
      '--video-ratio': ratio,
      '--video-width': width,
    }
  }
}
